



















































/* tslint:disable:max-classes-per-file */
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import GenericButton from '@/components/GenericButton.vue';
import { DataSetMetadata } from '../../types';
import DataSetService from '../../services/dataset.service';

@Component({
  components: {GenericButton},
})
export default class FieldSelectionCard extends Vue {
  @Prop() private preSelectedFields!: Array<Record<string, string>>;
  @Prop() private metadataPromise!: Promise<DataSetMetadata>;
  private treeData: Array<{[key: string]: any}> = [];
  private checked: Array<{[key: string]: string}> = [];
  private loading: boolean = false;
  private displayFields: Record<string, any> = {};
  private removedFields: Array<{[key: string]: string}> = [];

  private async mounted() {
    if (!this.treeData.length) {
      this.treeData = await this.getTreeData();
    }

    if (this.preSelectedFields && this.preSelectedFields.length) {
      this.preSelectedFields.forEach((f) => {
        if (f.checked) {
          this.checked.push(f);
        }
      });
    }
  }

  private get filtered(): Array<{[key: string]: string}> {
    return this.checked.filter((checked, index, self) =>
      index === self.findIndex((t) => t.value === checked.value),
    );
  }

  @Watch('treeData', {immediate: true})
  private onTreeLoad() {
    this.loading = !this.treeData.length;
  }

  @Watch('checked', {deep: true})
  private onCheck(newVal: Array<{[key: string]: string}>, oldVal: Array<{[key: string]: string}>) {
    oldVal.forEach((o) => {
      this.checked.map((c) => {
        if (o.value === c.value) {
          c.text = o.text;
        }
      });
      if (!newVal.map((e) => e.value).includes(o.value)) {
        o.text = o.value;
        delete this.displayFields[o.value];
        this.removedFields.push(o);
      }
    });
    this.emitData();
  }

  private async getTreeData() {
    return new MetadataParser().createFieldTree(await this.metadataPromise);
  }

  private changeField(field: {[key: string]: string}) {
    const index = this.checked.findIndex((s) => s.id === field.id);
    index >= 0 ? this.checked[index] = field : this.checked.push(field);

    this.emitData();
  }

  private emitData() {
    this.checked.forEach((s) => {
      this.displayFields[s.value] = {
        text: s.text,
        value: s.value,
        id: s.id,
      };
    });

    this.$emit('update:selected-fields', this.checked);
    this.$emit('update:display-fields', {displayFields: this.displayFields, removedFields: this.removedFields});
  }

  private removeField(fieldValue: string) {
    this.checked = this.checked.filter((s) => s.value !== fieldValue);
    this.emitData();
  }

  private resetField(fieldValue: string) {
    const fieldIndex = this.checked.findIndex((s) => s.value === fieldValue);
    this.checked[fieldIndex].text = fieldValue;
    this.emitData();
  }
}

class MetadataParser {
  public createFieldTree(metadata: DataSetMetadata): Array<{[key: string]: any}> {
    if ((!metadata.deviceTypes && !metadata.interfaces)
      || (metadata.deviceTypes && Object.keys(metadata.deviceTypes).length) === 0
      || (metadata.interfaces && Object.keys(metadata.interfaces).length) === 0) {
      throw new Error('This dataset does not yet contain any data');
    }
    return metadata.deviceTypes
      ? this.parseDeviceTypes(metadata)
      : this.parseInterfaces(metadata);
  }

  public parseDeviceTypes(metadata: DataSetMetadata) {
    return [{
      id: 'dt',
      text: 'Device Types',
      value: 'Device Types',
      children: Object.entries(metadata.deviceTypes).map((d, i) => {
        return {
          id: `${d[0]}`,
          text: d[0],
          value: d[0],
          children: Object.entries(d[1]).map((t: any[], k) => {
            return {
              id: `${d[0]}-${t[0]}`,
              text: t[0],
              value: t[0],
              children: t[1].map((c: string, index: number) => {
                return {
                  id: `${d[0]}-${t[0]}-${c}-${index}`,
                  text: c,
                  value: c,
                };
              }),
            };
          }),
        };
      }),
    }];
  }

  public parseInterfaces(metadata: DataSetMetadata) {
    return [{
      id: 'if',
      value: 'Interfaces',
      text: 'Interfaces',
      children: Object.entries(metadata.interfaces).map((i, j) => {
        return {
          id: `${i[0]}`,
          text: i[0],
          value: i[0],
          children: Object.entries(i[1]).map((t: any[], index: number) => {
            return {
              id: `${i[0]}-${t[0]}-${index}`,
              text: t[1],
              value: t[1],
            };
          }),
        };
      }),
    }];
  }
}
